import { render, staticRenderFns } from "./ProgramOutcomesSemesters.vue?vue&type=template&id=462e8603"
import script from "./ProgramOutcomesSemesters.vue?vue&type=script&lang=js"
export * from "./ProgramOutcomesSemesters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports